import { useEffect, useState } from "react";
import { useVideos } from "@/components/HeroVideo";

const probe = (id) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.naturalWidth > 120);
    img.onerror = () => resolve(false);
    img.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
  });

export const FeatureVideo = () => {
  const { data = [] } = useVideos();
  const video = data.find((v) => v.type === "feature");
  const [ok, setOk] = useState(false);
  useEffect(() => {
    let live = true;
    setOk(false);
    if (video?.youtube_id) probe(video.youtube_id).then((r) => live && setOk(r));
    return () => { live = false; };
  }, [video?.youtube_id]);
  if (!video || !ok) return null;
  return (
    <section className="max-w-5xl mx-auto px-5 sm:px-8 pb-14" data-testid="feature-video-section">
      {video.title && (
        <h2 className="font-type font-bold text-base md:text-lg text-[#1B2A41] uppercase tracking-wider mb-4">{video.title}</h2>
      )}
      <div className="aspect-video w-full rounded-2xl overflow-hidden shadow-xl border border-[#1B2A41]/10 bg-black">
        <iframe
          className="w-full h-full"
          src={`https://www.youtube.com/embed/${video.youtube_id}?rel=0`}
          title={video.title || "R.O.A.N video"}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid="feature-video-iframe"
        />
      </div>
    </section>
  );
};
